export default {
  BANCONTACT: 'Par bancontact',
  BANK_TRANSFER: 'Par virement',
  CASH: 'Par cash',
  GIFT_CARD: `Par bon d'achat`,
  CREDIT_NOTE: `Par note de crédit`,
}
